import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, RequestEmissaoPid } from './types';

// ACTIONS
import { gerarRenachSuccess, gerarRenachFailure } from './actions';

function* emissaoPid(request: ReducerAction) {
	const { payload }: { payload: RequestEmissaoPid } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`pid/${CHANNEL}/solicita/emissao`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(gerarRenachSuccess(response));
	} else if (response.error) {
		yield put(gerarRenachFailure());
	}
}

export default all([takeLatest(Types.EMISSAO_PID, emissaoPid)]);
